import { useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MarketingPage from './marketing-page/MarketingPage'
import Dashboard from './dashboard/dashboard'
import SignInSide from './sign-in-side/SignInSide'
import About from './about/About'
import LegalNotice from './dashboard/components/LegalNotice'
import Patients from './patient-details/Patients.jsx'
import Users from './users/Users.jsx'
import Hospitals from './hospitals/Hospitals.jsx'
import Errors from './errors/Errors.jsx'
import AdminRoute from './shared/guards/AdminRoute.js'
import AppTheme from './shared-theme/AppTheme'
import { SessionTimeoutGuard } from './shared/guards/SessionTimeoutGuard'
import { AuthProvider } from './shared/context/AuthContext'
import { UploadProvider } from './shared/context/UploadContext'
import UploadProgressPanel from './patient-details/components/UploadProgressPanel'
import MfaEnrollmentGuard from './mfa/MfaEnrollmentGuard.jsx'

function App() {
  const [page, setPage] = useState('Home')

  const publicRoutes = [
    { path: '/', element: <MarketingPage /> },
    { path: '/login', element: <SignInSide /> },
    { path: '/about', element: <About /> },
    { path: '/legal', element: <LegalNotice /> },
  ]

  const protectedRoutes = [
    { path: '/dashboard', element: <Dashboard page={page} setPage={setPage} /> },
    { path: '/patients', element: <Patients /> },
    { path: '/users', element: <AdminRoute><Users /></AdminRoute> },
    { path: '/hospitals', element: <AdminRoute><Hospitals /></AdminRoute> },
    { path: '/errors', element: <AdminRoute><Errors /></AdminRoute> },
  ]

  return (
    <div className="App">
      <AppTheme>
        <AuthProvider>
          <UploadProvider>
            <BrowserRouter basename={import.meta.env.PUBLIC_URL || '/'}>
              <Routes>
                {publicRoutes.map(({ path, element }) => (
                  <Route key={path} path={path} element={element} />
                ))}

                <Route
                  element={
                    <SessionTimeoutGuard
                      timeoutMinutes={import.meta.env.VITE_SESSION_TIMEOUT || 15}
                      warningOffsetMinutes={1}
                    />
                  }
                >
                  <Route element={<MfaEnrollmentGuard />}>
                    {protectedRoutes.map(({ path, element }) => (
                      <Route key={path} path={path} element={element} />
                    ))}
                  </Route>
                </Route>

                <Route path="*" element={<MarketingPage />} />
              </Routes>
            </BrowserRouter>
            <UploadProgressPanel />
          </UploadProvider>
        </AuthProvider>
      </AppTheme>
    </div>
  )
}

export default App
